export default {
  path: '/',
  component: () => import('@/layouts/LayoutContentAppNav.vue'),
  meta: { protected: true },
  children: [
    {
      path: 'manage/subjects/streams',
      name: 'ManageStreams',
      component: () => import('@/views/subjects/streams/ManageStreams.vue'),
    },
    {
      path: 'manage/subjects/streams/assign',
      name: 'AssignStreamSubjects',
      component: () => import('@/views/subjects/streams/AssignStreamSubjects.vue'),
    },
  ],
}
